module.exports = __webpack_public_path__ + "img/lookmap.fc8e4dc7.png";